module.exports = __webpack_public_path__ + "themify.9c8e96ecc7fa01e6ebcd.svg";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module chunks = styles